import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { CardComponent } from '../card.component';
import { Router } from '@angular/router';
// import { Product, ProductList, ProductService } from '../../../../generated';

@Component({
  selector: 'app-store-card',
  templateUrl: './store.component.html',
  styleUrls: ['./store.component.scss']
})
export class StoreCardComponent extends CardComponent implements OnInit {

  // productData: Product;

  @Input() classes = 'background-light general-light-bg';
  @Input() topLeftTextClasses = 'cream-mint';
  @Input() titleClasses = 'text-white h4-nc';
  @Input() bottomRight = '<i class=\'fas fa-shopping-cart\'></i>';
  @Input() descriptionClasses = 'gray3';
  @Input() linkText = 'View Details <i class=\'fas fa-arrow-right\'></i>';
  @Input() linkClasses = 'primary1-light';
  @Input() bottomRightClasses = 'h4-nc';
  @Input() bottomRightTextClasses = 'primary2-light';

  // CMS service
  // private readonly ProductService: ProductService

  constructor(
      sanitize: DomSanitizer,
      router: Router) {
    super(sanitize, router);
  }

  ngOnInit() {

  }

  // CMS funciton
  // async fetchData () {
  //   const productList: ProductList = await this.ProductService.getOrgsOrgnameProduct('global', true).toPromise();
  //   if (!!productList && !!productList[0]) {
  //     this.productData = productList[0];
  //   }
  // //console.log('init(): homepage data', this.productData);
  // }

}
